import { render, staticRenderFns } from "./m-preview-modal.vue?vue&type=template&id=552b1874&"
import script from "./m-preview-modal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-preview-modal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-preview-modal.vue?vue&type=style&index=0&id=552b1874&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports